module.exports = __webpack_public_path__ + "static/media/icon-close.6bb041a4.svg";